<!--

    Copyright (C) 2024 Das Land Schleswig-Holstein vertreten durch den
    Ministerpräsidenten des Landes Schleswig-Holstein
    Staatskanzlei
    Abteilung Digitalisierung und zentrales IT-Management der Landesregierung

    Lizenziert unter der EUPL, Version 1.2 oder - sobald
    diese von der Europäischen Kommission genehmigt wurden -
    Folgeversionen der EUPL ("Lizenz");
    Sie dürfen dieses Werk ausschließlich gemäß
    dieser Lizenz nutzen.
    Eine Kopie der Lizenz finden Sie hier:

    https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12

    Sofern nicht durch anwendbare Rechtsvorschriften
    gefordert oder in schriftlicher Form vereinbart, wird
    die unter der Lizenz verbreitete Software "so wie sie
    ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
    ausdrücklich oder stillschweigend - verbreitet.
    Die sprachspezifischen Genehmigungen und Beschränkungen
    unter der Lizenz sind dem Lizenztext zu entnehmen.

-->
<form [formGroup]="formService.form" (ngSubmit)="submit()">
  <odc-spinner [stateResource]="userStateResource$ | async">
    <div class="max-w-[960px]" data-test-id="user-content">
      <administration-user-form-headline [isPatch]="isPatch" />
      <administration-user-form-data [isPatch]="isPatch" [userName]="userName" />
      <administration-user-form-roles />
      <administration-user-form-organisations-einheit-list />
      <div class="mb-6 flex justify-between">
        <administration-user-form-save-button [submitStateResource$]="submitStateResource$" />
        @if (isPatch) {
          <administration-delete-open-dialog-button data-test-id="delete-button-container" />
        }
      </div>
    </div>
  </odc-spinner>
</form>
